export default __webpack_public_path__ + "static/media/flip-cel.a4dd803b.gif";